export default "/_next/static/images/e234f0baa296641425883a27b6eaa09c.jpg";